module.exports = __webpack_public_path__ + "static/media/home.08195f97.svg";